{
  "name": "frontend",
  "version": "1.6.12",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --ssl true",
    "build": "ng build",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.2.2",
    "@angular/common": "^22.2.2",
    "@angular/compiler": "^22.2.2",
    "@angular/core": "^22.2.2",
    "@angular/forms": "^22.2.2",
    "@angular/localize": "^22.2.2",
    "@angular/material": "^22.2.2",
    "@angular/platform-browser": "^22.2.2",
    "@angular/router": "^22.2.2",
    "@ngx-loading-bar/core": "^7.0.1",
    "@ngx-loading-bar/http-client": "^7.0.1",
    "@ngx-loading-bar/router": "^7.0.1",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "dayjs": "^1.11.23",
    "file-saver": "^2.0.5",
    "keycloak-js": "^26.2.4",
    "marked": "^18.1.0",
    "ng2-date-picker": "^22.0.0",
    "ngx-dynamic-hooks": "^3.1.2",
    "ngx-spinner": "^22.0.1",
    "rxjs": "~7.8.2",
    "sweetalert2": "^11.26.25",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.2",
    "@angular/cli": "^22.2.2",
    "@angular/compiler-cli": "^22.2.2",
    "@types/node": "^26.6.5",
    "@types/file-saver": "^2.0.7",
    "typescript": "~6.0.3"
  }
}
